import styled from 'styled-components';

export const ExpressionEditor = styled.span`
  font-family: Inconsolata;
`;

export const ExpressionEditorWrapper = styled.div`
  border: 1px solid;
  border-color: ${(props: {isInvalid?: boolean}) =>
    props.isInvalid ? '#ff5447' : '#bbb'};
  border-radius: 4px;
  padding: 6px 8px;
  min-width: 200px;
`;

export const ExpressionEditorContainer = styled.div`
  cursor: text;
`;
